/**
 * Client-side cache utility for API responses
 * Uses localStorage with TTL support
 */

const CACHE_PREFIX = 'ybs_cache_';

/**
 * Get cached data if valid
 * @param {string} key - Cache key
 * @param {number} ttlSeconds - Time to live in seconds
 * @returns {any|null} Cached data or null if expired/missing
 */
export const getCached = (key, ttlSeconds = 300) => {
  try {
    const cached = localStorage.getItem(CACHE_PREFIX + key);
    if (!cached) return null;
    
    const { data, timestamp } = JSON.parse(cached);
    const age = (Date.now() - timestamp) / 1000;
    
    if (age < ttlSeconds) {
      return data;
    }
    
    // Expired - remove it
    localStorage.removeItem(CACHE_PREFIX + key);
    return null;
  } catch (e) {
    return null;
  }
};

/**
 * Set cached data
 * @param {string} key - Cache key
 * @param {any} data - Data to cache
 */
export const setCached = (key, data) => {
  try {
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify({
      data,
      timestamp: Date.now()
    }));
  } catch (e) {
    // localStorage might be full or disabled
    console.warn('Cache write failed:', e);
  }
};

/**
 * Invalidate cache entry
 * @param {string} key - Cache key
 */
export const invalidateCache = (key) => {
  try {
    localStorage.removeItem(CACHE_PREFIX + key);
  } catch (e) {
    // Ignore
  }
};

/**
 * Clear all cached data
 */
export const clearAllCache = () => {
  try {
    Object.keys(localStorage)
      .filter(key => key.startsWith(CACHE_PREFIX))
      .forEach(key => localStorage.removeItem(key));
  } catch (e) {
    // Ignore
  }
};

// Cache keys
export const CACHE_KEYS = {
  CATEGORIES: 'categories',
  ISLANDS: 'islands',
};

// Default TTLs (in seconds)
export const CACHE_TTL = {
  CATEGORIES: 300, // 5 minutes
  ISLANDS: 300,    // 5 minutes
};
